import type { BottleClickerCoupon } from "@ziolo/shared";

export type WypłataReceiptData = {
  runGrosze: number;
  returnedBottles: number;
  lines: readonly { label: string; count: number; grosze: number }[];
  nextMult: number;
  bonusPct: number;
  chipsGranted: number;
  prestigeCountAfter: number;
  printedAt: Date;
  barcode: string;
  txnId: string;
};

const MONTHS_PL = [
  "STY",
  "LUT",
  "MAR",
  "KWI",
  "MAJ",
  "CZE",
  "LIP",
  "SIE",
  "WRZ",
  "PAŹ",
  "LIS",
  "GRU",
] as const;

/** Thermal-style `PLN 46.00` (dot decimals, like a butelkomat slip). */
export function formatReceiptPln(grosze: number): string {
  const zlote = Math.max(0, Math.trunc(grosze)) / 100;
  return `PLN ${zlote.toFixed(2)}`;
}

export function formatReceiptAmount(grosze: number): string {
  return (Math.max(0, Math.trunc(grosze)) / 100).toFixed(2);
}

export function formatReceiptStamp(date: Date): string {
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const month = MONTHS_PL[date.getMonth()] ?? "STY";
  return `${hh}:${mm}:${ss} ${day}-${month}-${date.getFullYear()}`;
}

export function couponToReceipt(coupon: BottleClickerCoupon): WypłataReceiptData {
  return {
    runGrosze: coupon.runGrosze,
    returnedBottles: coupon.returnedBottles,
    lines: coupon.lines,
    nextMult: coupon.nextMult,
    bonusPct: coupon.bonusPct,
    chipsGranted: coupon.chipsGranted,
    prestigeCountAfter: coupon.prestigeCountAfter,
    printedAt: new Date(coupon.printedAtMs || Date.now()),
    barcode: coupon.barcode,
    txnId: coupon.txnId,
  };
}
